export const isReferenceTab = (str) => str === 'benefitsCosts' ||
    str === 'pairings' ||
    str === 'tipsResources' ||
    str === 'remedies' ||
    str === 'dataLayers' ||
    str === 'documentation' ||
    str === 'tips' ||
    str === 'layers';
export const isPersistentPanelTab = (str) => str === 'benefits' ||
    str === 'conditions' ||
    str === 'details' ||
    str === 'sites';
// Sorting
export const sortingOptionsTuple = [
    'Name',
    'Email',
    'Organization',
    'Role',
    'ID'
];
export const sortingOptions = [...sortingOptionsTuple];
//# sourceMappingURL=ui.js.map